import {
  Component,
  computed,
  effect,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { filterOperatorLabels, filterOperatorNotLabels } from '../filter.i18n';
import {
  FilterCommand,
  FilterOperator,
  FilterSuffix,
} from '../../../api/api.operators';

@Component({
  selector: 'app-filter-operator',
  standalone: true,
  templateUrl: './filter-operator.component.html',
  styleUrl: './filter-operator.component.scss',
})
export class FilterOperatorComponent {
  operators = input<FilterOperator[]>();
  _operators = computed(
    () => this.operators() ?? Object.values(FilterOperator),
  );
  notOperators = input<FilterOperator[]>();
  _notOperators = computed(
    () => this.notOperators() ?? Object.keys(filterOperatorNotLabels),
  );
  operator = input<FilterCommand>(FilterOperator.LIKE);
  operatorSelectValue = computed(() => {
    const tokens = this.operator();
    return Array.isArray(tokens) ? tokens.join(':') : tokens;
  });
  operatorChange = output<FilterCommand>();
  selectElement = viewChild<ElementRef>('select');

  protected readonly filterOperatorLabels = filterOperatorLabels;
  protected readonly filterOperatorNotLabels = filterOperatorNotLabels;

  constructor() {
    // Somehow directly binding the select with [value] didn't work
    effect(() => {
      const elem = this.selectElement();
      if (elem) elem.nativeElement.value = this.operatorSelectValue();
    });
  }

  onChange($event: Event) {
    const value = ($event.target as HTMLSelectElement).value;
    const notOperator = value.split(':')[0] === FilterSuffix.NOT;
    if (notOperator)
      this.operatorChange.emit([
        FilterSuffix.NOT,
        value.split(':')[1] as FilterOperator,
      ]);
    else this.operatorChange.emit(value as FilterOperator);
  }

  protected readonly FilterSuffix = FilterSuffix;
  protected readonly FilterOperator = FilterOperator;
}
